// @vue/component
import CallPlannerItem from "./CallPlannerItem";

export default {
  name: "CallPlannerPopover",

  components: {
    CallPlannerItem
  },
  props: {
    holidayList: {
      type: Array,
      default: () => []
    },
    agentsList: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isShowListForToday: false,
      isPopoverVisible: false,
      isLoading: false,
      isTooltipVisible: false
    };
  },
  computed: {
    plannerList() {
      return this.$store.getters["callPlanner/plannerList"];
    },
    plannerListCount() {
      return this.$store.getters["callPlanner/plannerListCount"];
    },
    hasCallPlannerPermission() {
      return this.$store.getters["authorization/acl"].hasPermission("callplanner_menu_access");
    }
  },
  async created() {
    await this.$store.dispatch("callPlanner/getListCount");
    this.timer = setInterval(async () => {
      await this.$store.dispatch("callPlanner/getListCount");
    }, 1000 * 60 * 5);
    setTimeout(() => {
      this.isTooltipVisible = true;
    }, 5000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  watch: {
    isPopoverVisible: {
      handler() {
        this.getCallPlannerList();
      }
    }
  },
  methods: {
    goToCallPlanner() {
      this.$router.push({ name: "PlatformCallPlanner" });
      this.isPopoverVisible = false;
    },
    async getCallPlannerList() {
      this.isLoading = true;
      if (!this.isPopoverVisible) {
        await this.$store.dispatch("callPlanner/getListCount");
        this.isShowListForToday = false;
      } else {
        await this.$store.dispatch("callPlanner/getListCount");
        await this.$store.dispatch("callPlanner/getList", {
          type: this.isShowListForToday ? 1 : 0
        });
      }
      this.isLoading = false;
    },
    async refreshList() {
      this.isLoading = true;
      await this.$store.dispatch("callPlanner/getListCount");
      await this.$store.dispatch("callPlanner/getList", { type: this.isShowListForToday ? 1 : 0 });
      this.isLoading = false;
    }
  }
};
